export default {
    general: {
        name: null,
        cnpj: null,
        useType: null
    },

    access: {
        login: null,
        password: null
    },

    address: {
        zipCode: null,
        streetName: null,
        streetNumber: null,
        extra: null,
        neighborhood: null,
        city: null,
        state: null
    },

    masterUser: {
        email: null,
        name: null,
        phone: null
    },

    contacts: [
        {
            name: null,
            phone: null,
            email: null
        },

        {
            name: null,
            phone: null,
            email: null
        }
    ],

    tags: [],

    permissions: ['CREATE_CAMPAIGN', 'ADD_EXTRA_FIELD', 'CUSTOMIZE_CAPTIVE_PAGE', 'CUSTOMIZE_USE_TERMS', 'ALLOW_MULTIPLE_LOGINS', 'ALLOW_CREATE_USERS', 'ALLOW_TRACKERS']

};
